import { render, staticRenderFns } from "./HowItWorks.vue?vue&type=template&id=56b75b74&scoped=true&"
import script from "./HowItWorks.vue?vue&type=script&lang=js&"
export * from "./HowItWorks.vue?vue&type=script&lang=js&"
import style0 from "./HowItWorks.vue?vue&type=style&index=0&id=56b75b74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b75b74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
